import { render, staticRenderFns } from "./ThreadDetails.vue?vue&type=template&id=6d93e9ae&"
import script from "./ThreadDetails.vue?vue&type=script&lang=js&"
export * from "./ThreadDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports